<template>
  <w-flex
    tag="section"
    direction="col"
    align="stretch"
    class="form-section"
    :gap="4"
    :class="{ 'form-section--full': full }"
  >
    <w-flex v-if="title || $slots.title" class="form-section__title">
      <slot name="title">
        {{ title }}
      </slot>
    </w-flex>
    <slot />
  </w-flex>
</template>
<script setup lang="ts">
defineProps<{
  /**
   * Tytuł sekcji
   */
  title?: string;

  /**
   * Flaga określająca, czy sekcja ma zajmować całą dostępną szerokość
   */
  full?: boolean;
}>();
</script>

<style lang="scss">
.form-section {
  padding: w.size('tab-padding');
  width: 100%;
  max-width: 680px;

  &--full {
    max-width: 100%;
  }

  &__title {
    width: fit-content;
    background: w.color('neutral', 50);
    font-size: w.font('xsmall');
    font-weight: w.weight('semi-bold');
    color: w.color('neutral', 800);
    border-radius: w.radius('regular');
    padding: 2px 8px;
    text-transform: uppercase;
    margin-bottom: 12px;
  }

  .w-table-wrapper {
    width: 100%;
  }

  &:has(.w-table-wrapper) {
    padding-left: 0;
    padding-right: 0;

    .w-table-container {
      padding: 0 w.size('tab-padding');
    }

    .w-td,
    .w-th {
      &--sticky-left {
        &.w-td--is-stuck,
        &.w-th--is-stuck {
          left: -1 * (calc(w.size('tab-padding') + 2px));
        }
      }

      &--sticky-right {
        &.w-td--is-stuck,
        &.w-th--is-stuck {
          right: -1 * (calc(w.size('tab-padding') + 2px));
        }
      }
    }
  }
}
</style>
